<template>
  <v-dialog v-model="visible" width="600">
    <v-card>
      <v-card-title class="justify-space-between">
        WireGuard configuration file
        <v-chip v-if="deviceName" small class="ml-2">{{ deviceName }}</v-chip>
      </v-card-title>
      <v-card-subtitle>
        Remember to save this file as "/etc/wireguard/wg0.conf"
      </v-card-subtitle>
      <v-card-text>
        <div style="position: relative">
          <pre v-bind:class="[$vuetify.theme.dark ? 'grey darken-4' : 'grey lighten-2', 'pa-2 rounded wg-pre']">{{ value }}</pre>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn v-on:click="download" text>
          <v-icon left>mdi-download</v-icon>Download
        </v-btn>
        <v-spacer />
        <v-btn v-on:click="visible = false" text>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ItemWireGuardConfig",

  props: {
    value:      { type: String, default: null },
    deviceName: { type: String, default: null }
  },

  computed: {
    visible: {
      get() { return !!this.value; },
      set(value) { value === false && this.$emit("input", null); }
    }
  },

  methods: {
    download() {
      const blob = new Blob([this.value], { type: "text/plain" });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href     = url;
      a.download = "wg0.conf";
      a.click();
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.wg-pre { font-family: 'JetBrains Mono', 'Fira Code', 'Consolas', monospace; font-size: 12px; line-height: 1.6; overflow-x: auto; }
</style>
